import { Link } from "react-router-dom";
import { CONTACT_US } from "../constants";

const ContactUs = () => {
  return (
    <>
      You may also{" "}
      <Link
        className="contact-us-link"
        to={CONTACT_US}
        target="_blank"
        rel="noopener noreferrer"
      >
        contact us
      </Link>{" "}
      for additional support.
    </>
  );
};

export default ContactUs;
